export const DELETE_PACKAGE_ENTRY = "DELETE_PACKAGE_ENTRY";
export const CLEAR_CART = "CLEAR_CART";
export const BLOCK_SCREEN = "BLOCK_SCREEN";
export const UNBLOCK_SCREEN = "UNBLOCK_SCREEN";
export const SET_PACKAGE_ENTRIES = "SET_PACKAGE_ENTRIES";

export const CART_LOAD_START = "CartPage: LOAD_DATA_START";
export const CART_LOAD_SUCCESS = "CartPage: LOAD_DATA_SUCCESS";
export const CART_LOAD_FAIL = "CartPage: LOAD_DATA_FAIL";
